import React from 'react';
import PaperformNav from './PaperformNav';
import PapersignNav from './PapersignNav';
import useIsPapersign from '../../utils/useIsPapersign';

function Nav({ fixed, invert, isTry, location = undefined }) {
  const isPapersign = useIsPapersign(location);

  return isPapersign ? (
    <PapersignNav fixed={fixed} isTry={isTry} />
  ) : (
    <PaperformNav fixed={fixed} invert={invert} isTry={isTry} />
  );
}

export default Nav;
